import React from 'react';
import { DNABox, DNACheckbox, DNAText, Iffy } from '@alucio/lux-ui'
import { HelpCircleTooltip } from 'src/components/DNA';
import { styles } from 'src/components/Publishers/Styles';
import { usePublisherVersioningState }
  from 'src/state/machines/publisherVersioning/PublisherVersioningProvider';
import { NotificationScope } from '@alucio/aws-beacon-amplify/src/models';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';

const DocumentReleaseNotes: React.FC = () => {
  const { currentDocumentVersionORM } = usePublisherVersioningState();
  const featureFlags = useFeatureFlags('enableEmailNotification', 'BEAC_2777_immediate_publish_emails');
  if (!currentDocumentVersionORM) return null;
  return (
    <DNABox
      fill
      appearance="col"
      spacing="lg"
      style={styles.TabContentWrapper}
    >
      <Iffy is={featureFlags.enableEmailNotification}>
        <DNABox appearance="col" spacing="sm" fill>
          <DNABox
            testID="notify-users-email-checkbox"
            spacing="xs"
          >
            <DNACheckbox
              testID={true ? 'checkbox-checked' : 'checkbox-unchecked'}
              checked={currentDocumentVersionORM.model.notificationScope === NotificationScope.EMAIL}
              onChange={() => { }}
              disabled
            />

            <DNAText
              numberOfLines={3}
              ellipsizeMode="tail"
              bold
            >
              Notify users who have saved this file of new version
            </DNAText>
            <HelpCircleTooltip
              // eslint-disable-next-line max-len
              popoverText="Users who have saved this file in their folders will receive an email notification at the end of the day."
            />
          </DNABox>
          {featureFlags.BEAC_2777_immediate_publish_emails && <DNABox
            testID="notify-users-email-immediately-checkbox"
            childFill={1}
            spacing="xs"
          >
            <DNACheckbox
              testID={true ? 'checkbox-immediately-checked' : 'checkbox-immediately-unchecked'}
              checked={currentDocumentVersionORM.model.notificationScope === NotificationScope.EMAIL_IMMEDIATE}
              onChange={() => { }}
              disabled
            />
            <DNABox>
              <DNAText
                numberOfLines={3}
                ellipsizeMode="tail"
                bold
              >
                Notify all users of new version immediately
              </DNAText>
              <HelpCircleTooltip popoverText="All users will immediately receive an email notification." />
            </DNABox>
          </DNABox>}
        </DNABox>
      </Iffy>
      <DNABox style={{ maxWidth: 560 }} appearance="col" spacing="sm">
        <DNAText bold>Revision Level</DNAText>
        <DNAText>
          {currentDocumentVersionORM.model.changeType === 'MAJOR' ? 'Major Change' : 'Minor Change'}
        </DNAText>
      </DNABox>
      <DNABox style={{ maxWidth: 560 }} appearance="col" spacing="sm">
        <DNAText bold>Release Notes</DNAText>
        <DNAText>
          {currentDocumentVersionORM.model.releaseNotes}
        </DNAText>
      </DNABox>
    </DNABox>
  )
}

export default DocumentReleaseNotes
